import { Select } from '@mantine/core'

import { useQuery } from '@redwoodjs/web'

import { GET_TRAININGS } from 'src/graphql/trainings.graphql'

import { inlineSelectProps } from './inlineSelectStyles'

const TrainingOptions = ({ selectedLesson, setSelectedLesson }) => {
  const { data: trainings } = useQuery(GET_TRAININGS)

  const trainingList =
    trainings?.trainings?.items?.map((training) => {
      return {
        value: training?.trainingId,
        label: `${training?.name} (${training.language})`,
      }
    }) || []

  return (
    <div className="flex flex-col gap-3 text-xs">      {trainingList.length === 0 ? (
        <div className="text-xs text-doubleNickel-gray-500">
          No trainings found.
        </div>
      ) : (
        <Select
          {...inlineSelectProps}
          value={selectedLesson?.trainingId}
          onChange={(value) => setSelectedLesson({ trainingId: value })}
          data={trainingList}
          className="max-w-sm"
          searchable
        />
      )}
    </div>
  )
}

export default TrainingOptions
